import { checkMobileAndRedirect } from './redirect-to-mobile.js'

const RedirctToMobileMixins = {
  methods: {
    checkMobileAndRedirect
  }
}
export default RedirctToMobileMixins
